import * as actionTypes from "./actionTypes";
import axios from "axios";
// import { toast } from "react-toastify";
const Url = process.env.REACT_APP_MAIN_URL;

export const getCars = () => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING,
    payload: true,
  });
  axios
    .get(`${Url}car`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      dispatch({
        type: actionTypes.GET_Cars,
        payload: response.data,
      });
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      if (error?.response?.status === 404) {
        dispatch({
          type: actionTypes.GET_Cars,
          payload: {},
        });
      }
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
    });
};

export const getCarsById = (carId) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING,
    payload: true,
  });
  axios
    .get(`${Url}car/${carId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      dispatch({
        type: actionTypes.GET_Cars_By_Id,
        payload: response?.data?.data?.doc,
      });
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
    });
};
